<template>
  <div
    class="tkBadge"
    :class="{ '-removable': removable }"
    :style="{
      'max-width': maxWidth ? `${maxWidth}px` : undefined,
      'padding-top': `${paddingTop}px`,
      'padding-bottom': `${paddingBottom}px`,
      'font-weight': fontWeight,
    }"
    @click="removable && $emit('remove')"
  >
    <tk-cross-mark
      v-if="removable"
      class="tkBadge_crossmark"
      :width="2"
      :length="7"
    />
    <slot />
  </div>
</template>

<script>
import TkCrossMark from '../TkCrossMark/TkCrossMark'

export default {
  name: 'TkBadge',
  components: { TkCrossMark },
  props: {
    removable: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 188,
    },
    paddingTop: {
      type: Number,
      default: 4,
    },
    paddingBottom: {
      type: Number,
      default: 3,
    },
    fontWeight: {
      type: String,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
.tkBadge {
  position: relative;
  padding-right: 11px;
  padding-left: 9px;
  overflow: hidden;
  border: 1px solid;
  border-radius: 2em;
  font-size: 12px;
  letter-spacing: -0.05em;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;

  &.-removable {
    padding-left: 24px;
    color: #347ab0;
    cursor: pointer;
  }
}
.tkBadge_crossmark {
  position: absolute;
  left: 6px;
  top: 7px;
}
</style>
